import React, { useState, useRef, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import '../styles/Expertpreview.css';
import { FaBell, FaUserCircle } from 'react-icons/fa';
import axios from 'axios';
import { toast } from 'react-toastify';

const Expertpreview = () => {
  const [activeItem, setActiveItem] = useState('papers');
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  const [typeOfPaper, setTypeOfPaper] = useState('');
  const [papername, setPapername] = useState('');
  const [date, setDate] = useState('');
  const [duration, setDuration] = useState('');
  const [totalmarks, setTotalmarks] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [board, setBoard] = useState(null);
  const [grade, setGrade] = useState(null);
  const [subject, setSubject] = useState(null);

  const [rows, setRows] = useState([]);
  const [selectedQuestionsForSave, setSelectedQuestionsForSave] = useState(null);

  const toggleDropdown = () => setShowDropdown(prev => !prev);

  const [dashboardData, setDashboardData] = useState({
    totalBoard: 0,
    totalGrade: 0,
    totalSubjects: 0,
    totalPapers: 0,
    totalQuestions: 0,
  });

  const [user, setUser] = useState({ id: null, name: '', email: '', password: '' });

  const [questions, setQuestions] = useState([]);

  const cleanHTML = (text) => {
    return text?.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, '').trim() || '';
  };

  const extractImageFromHTML = (html) => {
    if (!html) return null;
    const match = html.match(/<img[^>]+src=["']([^"']+)["']/i);
    return match ? match[1] : null;
  };

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await axios.get('https://digital.tifleducation.com/admin/public/api/getDashboard', {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (res.data) {
          setDashboardData({
            totalBoard: res.data.totalBoards || 0,
            totalGrade: res.data.totalGrades || 0,
            totalSubjects: res.data.totalSubjects || 0,
            totalPapers: res.data.totalPapers || 0,
            totalQuestions: res.data.totalQuestions || 0,
          });
          if (res.data.user) {
            setUser({
              id: res.data.user.id,
              name: res.data.user.name || '',
              email: res.data.user.email || '',
              password: '',
            });
          }
        }
      } catch (error) {
        console.error('Error fetching dashboard data:', error.response?.data || error);
      }
    };
    fetchDashboardData();
  }, []);

  useEffect(() => {
    try {
      const data = localStorage.getItem('expertPreviewData');

      const rowsCandidates = [
        'expertRows',
        'expert_rows',
        'expert-rows',
        'expertRowsRaw',
        'expertRowsSaved',
      ];
      let parsedRows = null;
      for (const k of rowsCandidates) {
        const v = localStorage.getItem(k);
        if (v) {
          try {
            parsedRows = JSON.parse(v);
            if (Array.isArray(parsedRows)) break;
          } catch (e) {
            console.warn('Failed parsing expert rows key', k, e);
            parsedRows = null;
          }
        }
      }

      if (parsedRows) setRows(parsedRows);

      const selectedCandidates = [
        'expertSelectedQuestions',
        'expertSelected',
        'expert_selected_questions',
        'expertSelectedQuestionsRaw',
        'expertSelectedSaved'
      ];
      for (const k of selectedCandidates) {
        const v = localStorage.getItem(k);
        if (v) {
          try {
            const parsed = JSON.parse(v);
            setSelectedQuestionsForSave(parsed);
            break;
          } catch (e) {
            console.warn('Failed parsing selected questions key', k, e);
          }
        }
      }

      if (data) {
        const parsedData = JSON.parse(data);
        setBoard(parsedData.board || null);
        setGrade(parsedData.grade || null);
        setSubject(parsedData.subject || null);

        if (!selectedQuestionsForSave && parsedData.selected_questions) {
          setSelectedQuestionsForSave(parsedData.selected_questions);
        }

        if (parsedData.questions && parsedData.questions.length > 0) {
          const allQuestions = parsedData.questions.map((q) => {
            const text = cleanHTML(q.question_title || q.question || q.question_text || q.title || q.name || '');
            const originalId = q.id || q.question_id || q.qid || null;

            if (q.type === 'Matching Types') {
              const leftRaw = Array.isArray(q.left_column) ? q.left_column.join(' ') : q.left_column || '';
              const rightRaw = Array.isArray(q.right_column) ? q.right_column.join(' ') : q.right_column || '';
              const left_column = cleanHTML(leftRaw).split(/\d+\.\s*/).filter(Boolean).map(item => item.trim());
              const right_column = cleanHTML(rightRaw).split(/\([a-z]\)\s*/).filter(Boolean).map(item => item.trim());
              return { id: originalId, type: q.type, question_text: text, left_column, right_column };
            }

            if (q.type === 'True-False') return { id: originalId, type: q.type, question_text: text, options: ['True', 'False'] };

            if (q.type === 'Diagram-Based_Image-Based Questions') {
              let imageUrl = q.image || q.diagram || q.file || q.file_path || null;
              if (!imageUrl) imageUrl = extractImageFromHTML(q.question_title || q.question || '');
              const fullUrl = imageUrl ? (imageUrl.startsWith('http') ? imageUrl : `https://digital.tifleducation.com/admin/public/${imageUrl.replace(/^\/+/, '')}`) : null;
              return { id: originalId, type: q.type, question_text: cleanHTML(q.question_title || q.question || ''), image: fullUrl, options: q.options || [] };
            }

            return { id: originalId, type: q.type || 'Unknown', question_text: text, options: q.options || q.choices || [] };
          });

          setQuestions(allQuestions);
        } else {
          toast.warning('No questions found. Please generate expert paper first.');
        }
      } else {
        toast.warning('No preview data found. Please generate expert paper first.');
      }
    } catch (e) {
      console.error('Error while restoring preview data:', e);
    }
  }, []);

  const handleSaveProfile = async () => {
    try {
      const token = localStorage.getItem('token');
      await axios.post(
        'https://digital.tifleducation.com/admin/public/api/update-profile',
        { name: user.name, password: user.password },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success('Profile updated successfully!');
      setIsModalOpen(false);
      setUser({ ...user, password: '' });
    } catch (error) {
      console.error('Error updating profile:', error.response?.data || error);
      toast.error('Failed to update profile');
    }
  };

  const handleExportPaper = async () => await handleSaveAndExport('paper');
  const handleExportAnswerKey = async () => await handleSaveAndExport('answerKey');

  const normalizeRowsForStore = (rawRows) => {
    if (!Array.isArray(rawRows)) return [];
    return rawRows.map((r) => {
      const question_type = r.question_type || r.questionType || r.type || r.question_type_label || r.question_type_name || r.questionTypeLabel || '';
      const question_count = Number(r.question_count ?? r.questionCount ?? r.count ?? 0);
      const difficulty_level = r.difficulty_level ?? r.difficulty ?? r.level ?? null;
      const chapter_id = r.chapter_id ?? r.chapter ?? r.chapterId ?? r.chapter_index ?? null;
      return {
        question_type: String(question_type),
        question_count: Number.isNaN(question_count) ? 0 : question_count,
        difficulty_level: difficulty_level === undefined ? null : difficulty_level,
        chapter_id: chapter_id !== null && chapter_id !== undefined ? Number(chapter_id) : null,
      };
    });
  };

  const handleSaveAndExport = async (exportType) => {
    try {
      const token = localStorage.getItem('token');

      if (!papername || !date || !duration || !totalmarks || !board || !grade || !subject) {
        toast.error('Please fill all required fields');
        return;
      }
      if (!typeOfPaper) {
        toast.error('Please select Type of Paper');
        return;
      }

      if (!rows || rows.length === 0) {
        toast.error('No expert rows found. Cannot export paper.');
        return;
      }

      const rawRows = normalizeRowsForStore(rows);

      const typeMap = {
        'true-false': 'true_false',
        'diagram-based_image-based questions': 'diagram_image_based',
        'mcq': 'mcq',
        'fill_in_the_blanks': 'fill_in_the_blanks',
        'very_short_qa': 'very_short_qa',
        'short_qa': 'short_qa',
        'long_qa': 'long_qa',
        'matching_type': 'matching_type',
      };

      const expert_rows = rawRows.map(r => ({
        ...r,
        question_type: typeMap[r.question_type] || r.question_type,
        difficulty_level: r.difficulty_level
          ? r.difficulty_level.charAt(0).toUpperCase() + r.difficulty_level.slice(1).toLowerCase()
          : null,
      }));

      if (!Array.isArray(expert_rows) || expert_rows.length === 0) {
        toast.error('No valid expert rows available to send to server.');
        return;
      }

      // Filter out rows with zero question_count to prevent 422
      const filteredRows = expert_rows.filter(r => r.question_count > 0);
      if (filteredRows.length !== expert_rows.length) {
        toast.warning('Some rows with zero question count were skipped to prevent errors.');
      }

      const payload = {
        board: Number(board),
        grade: Number(grade),
        subject: Number(subject),
        paper_name: papername,
        date,
        duration: duration || null,
        total_marks: totalmarks ? Number(totalmarks) : null,
        action: 'export',
        paper_type: 'expert',
        type_of_paper: typeOfPaper,
        expert_rows: filteredRows,
      };

      if (selectedQuestionsForSave) payload.selected_questions = selectedQuestionsForSave;

      const res = await axios.post('https://digital.tifleducation.com/admin/public/api/papers', payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const savedPaperId = res.data?.response?.id || res.data?.data?.id || res.data?.id;
      if (!savedPaperId) {
        console.error('Save response:', res.data);
        toast.error('Failed to get saved paper ID');
        return;
      }

      const exportUrl =
        exportType === 'answerKey'
          ? `https://digital.tifleducation.com/admin/public/papers/export-answer-key/${savedPaperId}`
          : `https://digital.tifleducation.com/admin/public/papers/export/${savedPaperId}`;

      const link = document.createElement('a');
      link.href = exportUrl;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      document.body.appendChild(link);
      link.click();
      link.remove();

      toast.success(`${exportType === 'answerKey' ? 'Answer Key' : 'Paper'} exported successfully!`); 
      setTimeout(() => {
        window.location.href = '/papers/mypapers'; // <-- redirect
      }, 500);
    } catch (error) {
      console.error('Error saving/exporting paper:', error.response?.data || error);
      const msg =
        error.response?.data?.message ||
        (error.response?.data?.errors && JSON.stringify(error.response.data.errors)) ||
        'Failed to save/export paper';
      toast.error(typeof msg === 'string' ? msg : 'Failed to save/export paper (see console)');
    }
  };

  return (
    <div className="dashboard-container">
      <Sidebar
        isSidebarOpen={isSidebarOpen}
        setIsSidebarOpen={setIsSidebarOpen}
        activeItem={activeItem}
        setActiveItem={setActiveItem}
      />

      <main className="main-content">
        <div className="expertpre-header">
          <div className="expertpre-welcome-text">
            <a href="/expertpaper" className="back-link">
              <i className="fa fa-arrow-left" aria-hidden="true"></i>
            </a>
            <span className="expertpre-welcome-text">Expert Preview Paper</span>
          </div>
          <div className="header-icons" ref={dropdownRef}>
            <FaBell className="icon" />
            <div className="user-dropdown-wrapper">
              <FaUserCircle className="icon" onClick={() => setShowDropdown((p) => !p)} />
              {showDropdown && (
                <div className="user-dropdown">
                  <div className="edituser" onClick={() => setIsModalOpen(true)}>
                    <FaUserCircle className="ditusericon" />
                    <span>Edit Profile</span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Paper Details */}
        <div className="dropdown-row">
          <div className="dropdown-group">
            <label>
              Paper Name <span style={{ color: 'red' }}>*</span>
            </label>
            <input type="text" className="input-field" value={papername} onChange={(e) => setPapername(e.target.value)} placeholder="Enter Paper Name" required />
          </div>

          <div className="dropdown-group">
            <label>
              Type of Paper <span style={{ color: 'red' }}>*</span>
            </label>
            <select value={typeOfPaper} onChange={(e) => setTypeOfPaper(e.target.value)}>
              <option value="">Select Type of Paper</option>
              <option value="Worksheet">Worksheet</option>
              <option value="Assessment">Assessment</option>
            </select>
          </div>

          <div className="dropdown-group">
            <label>
              Date <span style={{ color: 'red' }}>*</span>
            </label>
            <input type="date" className="input-field" value={date} onChange={(e) => setDate(e.target.value)} required />
          </div>
          <div className="dropdown-group">
            <label>
              Duration <span style={{ color: 'red' }}>*</span>
            </label>
            <input type="text" className="input-field" value={duration} onChange={(e) => setDuration(e.target.value)} placeholder="Enter Duration" required />
          </div>
          <div className="dropdown-group">
            <label>
              Total Marks <span style={{ color: 'red' }}>*</span>
            </label>
            <input type="number" className="input-field" value={totalmarks} onChange={(e) => setTotalmarks(e.target.value)} placeholder="Enter Total Marks" required />
          </div>
        </div>

        {/* Questions */}
        <div className="expertpreviw-questions-container">
          {questions.length > 0 ? (
            questions.map((q, index) => (
              <div key={index} className="expertpreviw-question-box">
                <div className="expertpreviw-question">
                  <span className="expert-question-text">{index + 1}. {q.question_text}</span>
                </div>

                {/* Matching Types */}
                {q.type === 'Matching Types' && q.left_column && q.right_column && (
                  <div className="matching-columns" style={{ display: 'flex', gap: '3rem', marginTop: '1rem' }}>
                    <div className="left-column" style={{ flex: 1, display: 'grid', gap: 5 }}>
                      {q.left_column.map((item, i) => <div key={i}>{i + 1}. {item}</div>)}
                    </div>
                    <div className="right-column" style={{ flex: 1, display: 'grid', gap: 5 }}>
                      {q.right_column.map((item, i) => <div key={i}>({String.fromCharCode(97 + i)}) {item}</div>)}
                    </div>
                  </div>
                )}

                {/* Diagram / Image Based Questions */}
                {q.type === 'Diagram-Based_Image-Based Questions' && (
                  <div className="diagram-question" style={{ marginTop: '1rem' }}>
                    {q.image ? (
                      <img src={q.image} alt={`Diagram Question ${index + 1}`} style={{ width: 300, height: 300, objectFit: 'contain' }} />
                    ) : (
                      <p style={{ color: 'red' }}>Image not available</p>
                    )}
                    {q.options && q.options.length > 0 && (
                      <div className="expertpreviw-options">
                        {q.options.map((opt, idx) => (
                          <div key={idx}>{String.fromCharCode(65 + idx)}. {opt}</div>
                        ))}
                      </div>
                    )}
                  </div>
                )}

                {/* True/False */}
                {q.type === 'True-False' && (
                  <div className="expertpreviw-options" style={{ marginTop: '0.5rem' }}>
                    {q.options && q.options.map((opt, idx) => <div key={idx}>{opt}</div>)}
                  </div>
                )}

                {/* MCQ / Short / Very Short */}
                {q.type !== 'Matching Types' && q.type !== 'Diagram-Based_Image-Based Questions' && q.type !== 'True-False' && q.options && q.options.length > 0 && (
                  <div className="expertpreviw-options" style={{ marginTop: '0.5rem' }}>
                    {q.options.map((opt, idx) => <div key={idx}>{String.fromCharCode(65 + idx)}. {opt}</div>)}
                  </div>
                )}
              </div>
            ))
          ) : (
            <p>No questions available. Please generate expert paper first.</p>
          )}

          <div className="expert-next-button-container" style={{ marginTop: '1rem' }}>
            <button className="export-btn" onClick={handleExportPaper}>Export Paper</button>
            &nbsp;
            <button className="export-btn" onClick={handleExportAnswerKey}>Export Answer Key</button>
          </div>
        </div>
      </main>

      {isModalOpen && (
        <div style={modalStyles.overlay}>
          <div style={modalStyles.modal}>
            <button style={modalStyles.closeBtn} onClick={() => setIsModalOpen(false)}>&times;</button>
            <div style={modalStyles.userIcon}><FaUserCircle /></div>

            <div style={modalStyles.formGroup}>
              <label>Username</label>
              <input type="text" value={user.name} onChange={(e) => setUser({ ...user, name: e.target.value })} style={modalStyles.input} />
            </div>

            <div style={modalStyles.formGroup}>
              <label>Email</label>
              <input type="email" value={user.email} disabled style={{ ...modalStyles.input, background: '#f0f0f0', color: '#888' }} />
            </div>

            <div style={modalStyles.formGroup}>
              <label>Password</label>
              <input type="password" value={user.password} onChange={(e) => setUser({ ...user, password: e.target.value })} style={modalStyles.input} />
            </div>

            <div style={{ textAlign: 'right' }}>
              <button style={modalStyles.saveBtn} onClick={handleSaveProfile}>Save Changes</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const modalStyles = {
  overlay: { position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0,0,0,0.6)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 },
  modal: { background: '#fff', padding: '2rem', borderRadius: '12px', width: '90%', maxWidth: '400px', position: 'relative', boxShadow: '0 4px 15px rgba(0,0,0,0.2)' },
  closeBtn: { position: 'absolute', top: '10px', right: '15px', background: 'none', border: 'none', fontSize: '1.5rem', cursor: 'pointer' },
  userIcon: { textAlign: 'center', fontSize: '4rem', color: '#129255', marginBottom: '1rem' },
  formGroup: { marginBottom: '1rem' },
  input: { width: '100%', padding: '0.5rem 0.8rem', borderRadius: '6px', border: '1px solid #ccc', outline: 'none' },
  saveBtn: { background: '#129255', color: '#fff', border: 'none', padding: '0.6rem 1.2rem', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold' }
};

export default Expertpreview;
